<template>
  <v-card flat>
    <v-alert
      :value="true"
      class="mb-3 mt-0"
      type="info"
    >
      {{ $t('attention') }}
    </v-alert>

    <v-card-text>
      <v-form
        v-model="emailSettingsForm"
        @submit.prevent="() => {}"
        @keyup.native.enter="editPersonalInfo">
        <email-input
          :error-messages="errorMessages.email"
          v-model="email"
          required="true"/>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading || !emailSettingsForm"
        color="primary"
        @click="editPersonalInfo()"
      >
        {{ $t('edit') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'

export default {
  name: 'EmailSettings',
  components: { EmailInput },
  props: [],
  data () {
    return {
      isLoading: false,
      emailSettingsForm: true,
      errorMessages: {},
      email: ''
    }
  },
  computed: {
    ...mapGetters('user', ['getUser'])
  },
  methods: {
    async editPersonalInfo () {
      if (!this.emailSettingsForm) return

      this.isLoading = true
      try {
        const result = await UserApi.updateEmail({ email: this.email })
        this.$notification(result)
      } catch (e) {
        this.errorMessages = e.errors
      }
      this.isLoading = false
    }
  },
  watch: {
    email () { this.errorMessages = {} }
  },
  i18n: {
    messages: {
      en: {
        attention: 'A new email address wont be accepted until you verify it',
        edit: 'Save new email'
      },
      tr: {
        attention: 'Siz doğrulayana kadar yeni bir e-posta adresi kabul edilmeyecektir',
        edit: 'Yeni e-postayı kaydet'
      },
      de: {
        attention: 'Eine neue Email Adresse wird erst akzeptiert, nachdem Sie diese bestätigt haben. ',
        edit: 'Speichern'
      },
      ru: {
        attention: 'Новый адрес электронной почты не будет принят до тех пор, пока вы не подтвердите его.',
        edit: 'Сохранить новый эл. адрес'
      }
    }
  },
  created () {
    this.email = this.getUser.email
  }
}
</script>
